


















import { TemplateEnvioAutomatico } from "@/services/envios-automaticos.service";
import { Component, Prop, Vue } from "vue-property-decorator";


@Component
export default class TemplatePreview extends Vue {
    @Prop({ required: true })
    template!: TemplateEnvioAutomatico;

    get texto(): string {
        if (!this.template.texto) return '';

        return this.template.texto
            // Neg  rito: *texto* -> <strong>texto</strong>
            .replace(/\*([^*\n]+)\*/g, '<strong>$1</strong>')
            // Itálico: _texto_ -> <em>texto</em>
            .replace(/_([^_\n]+)_/g, '<em>$1</em>')
            // Riscado: ~texto~ -> <del>texto</del>
            .replace(/~([^~\n]+)~/g, '<del>$1</del>')
            // Monospace: ```texto``` -> <code>texto</code>
            .replace(/```([^`]+)```/g, '<code>$1</code>')
            // Variáveis {{n}} -> <span class="variable">{{n}}</span>
            .replace(/\{\{(\d+)\}\}/g, '<span class="variable">{{$1}}</span>')
            // Quebras de linha duplas -> <br><br>
            .replace(/\n\n/g, '<br><br>')
            // Quebras de linha simples -> <br>
            .replace(/\n/g, '<br>');
    }
}
